import React, { FC } from 'react';
import { Button, Theme, styled } from '@material-ui/core';
import { FontAwesomeSpriteIcon } from '../FontAwesomeLocal';
import { SpriteIcon, SpriteIconsLight } from 'src/config/api/models/FontAwesome';

type Props = {
  icon?: SpriteIcon;
  onClick: (event: React.MouseEvent<EventTarget>) => void;
  disableButtonStyle?: boolean;
  square?: boolean;
  fullWrapper?: boolean;
  iconSize?: 'lg' | 'md' | 'sm';
};

export const StyledIconContainer = styled(Button)<Theme, { fullwrapper: 'true' | 'false' }>(
  ({ theme, fullwrapper }) => ({
    ...(fullwrapper === 'true' && {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '3rem',
      height: '3rem',
      minWidth: '3rem',
      padding: '0.4rem',
      border: `1px solid ${theme.palette.grey['100']}`,
      borderRadius: 25,
    }),
    '&.square': {
      borderRadius: 0,
      top: 0,
      background: '#ffffff',
      boxShadow: `0 0 .3rem -0.2rem ${theme.palette.grey['400']}`,
      width: '3.2rem',
      height: '3.2rem',
    },
    '&:hover': {
      backgroundColor: theme.palette.grey['100'],
    },
    '&:disabled': {
      border: 'none',
      borderRadius: 0,
      backgroundColor: 'inherit',
    },
    minWidth: '1rem',
  })
);

const IconButtonSecondary: FC<Props> = ({
  icon,
  onClick,
  square,
  iconSize,
  fullWrapper = true,
}) => {
  return (
    <StyledIconContainer
      fullwrapper={fullWrapper ? 'true' : 'false'}
      className={square ? 'square' : undefined}
      onClick={onClick}
    >
      <FontAwesomeSpriteIcon
        icon={icon ?? SpriteIconsLight.ELLIPSIS}
        color={'grey'}
        iconSize={iconSize ?? 'md'}
      />
    </StyledIconContainer>
  );
};

export default IconButtonSecondary;
